import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Dialog, DialogTitle, DialogContent, FormControlLabel } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon, Image, Spinner } from 'ui'
import { Button, Table, TableBody, TableCell, TableRow, TableHead, RadioGroup, Radio, Checkbox, IconButton,  Select, InputLabel, MenuItem } from '@material-ui/core'
import { Edit, Delete, Add, Close, Phone } from '@material-ui/icons'

import { TextField } from '@material-ui/core'
import { observer } from 'mobx-react'
import useStore from 'store'
import FamilyIcon from 'assets/icons/ims/Family.svg'
import FamilyIcon2 from 'assets/icons/ims/Family2.svg'
import FamilyIcon3 from 'assets/icons/ims/family/icon1.svg'
import FamilyIcon4 from 'assets/icons/ims/family/icon2.svg'
import FamilyIcon5 from 'assets/icons/ims/family/icon3.svg'
import FamilyIcon6 from 'assets/icons/ims/family/icon4.svg'
import ChildIcon from 'assets/icons/ims/Child.svg'
import Household from 'assets/icons/ims/Household.svg'
import Users2 from 'assets/icons/ims/Users2.svg'
import Users3 from 'assets/icons/ims/Users3.svg'
import User5 from 'assets/icons/ims/User5.svg'
import User6 from 'assets/icons/ims/User6.svg'
import CloseIcon from 'assets/icons/ims/Close4.svg'
import EditIcon2 from 'assets/icons/ims/Edit2.svg'
import Alert2 from 'assets/icons/ims/Alert2.svg'
import Search from 'assets/icons/Search.svg'
import { ValidatedInput, ValidatedPopulationInput } from '../ValidatedInput'
import { fetchHouseholds } from '../mockUsersApi'
import DateInputWithCalendar from '../CalendarInput'

const ActionsImage = styled(Image)`
  width: 16px;
  height: 16px;
`

const FamilyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 23.992px;
  align-self: stretch;
`
const FamilyContainerBeitAv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  align-self: stretch;
`
const FamilyContainerBeitAvHeader = styled.div`
  display: flex;
  height: 26.989px;
  justify-content: flex-start;
  align-items: center;
  gap: 7.997px;
  align-self: stretch;
  color: #59168B;
  text-align: right;
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 27px;
`                                                      
const FamilyContainerSpourse = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 11.989px;
  align-self: stretch;

` 
const Button3 = styled(Button)`
  color: #64748B; 
  text-align: center;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  display: flex;
  padding: 9px 13px;
  justify-content: center;  
  align-items: center;
  gap: 8px;
  border-radius: 6px; 
  border: 0.909px solid #64748B;
`
const FamilyButtonContainer = styled.div`
  display: flex;
  height: 41.804px;
  padding: 0 0 0 -0.014px;
  justify-content: center;
  align-items: flex-start;
  gap: 7.997px;
  align-self: stretch;display: flex;
  height: 41.804px;
  padding: 0 0 0 -0.014px;
  justify-content: center;
  align-items: flex-start;
  gap: 7.997px;
  align-self: stretch;
`
const ButtonFamily1 = styled(Button)`
&:hover {
    border: 1px solid #2563EB;
    color: white;
    background: #2563EB;
  }
  display: flex;
  height: 42px;
  padding: 7px 20px;
  justify-content: center;
  align-items: center;
  gap: 7px;
  flex: 1 0 0;
  border-radius: 6px;
  border: 1px solid ${p => p.active ? '#2563EB' : '#E7EBF3'};
  color: ${p => p.active ? 'white' : theme.color.black};
  background: ${p => p.active ? '#2563EB' : '#F1F5F9'};
`
const ButtonFamily2 = styled(Button)`
  &:hover {
    border: 1px solid #2563EB;
    color: white;
    background: #2563EB;
  }
  display: flex;
  height: 42px;
  padding: 7px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 6px;
  border: 1px solid ${p => p.active ? '#2563EB' : '#E7EBF3'};
  color: ${p => p.active ? 'white' : theme.color.black};
  background: ${p => p.active ? '#2563EB' : '#F1F5F9'};
`
const Section = styled.div`
  display: flex;
  padding: 26px;
  flex-direction: column;
  align-items: flex-start;
  gap: 23.991px;
  align-self: stretch;
  border-radius: 12px;
  border: 1.818px solid rgba(233, 212, 255, 0.50);
  background: linear-gradient(135deg, #FAF5FF 0%, #F5F3FF 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10);
`
const FamilyHeader = styled.div`
  display: flex;
  height: 53.793px; 
  width: 100%;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-bottom: 1.818px solid #E9D4FF;
`
const ImageIcon3 = styled(Image)`
  display: flex;
  width: 39.986px;
  height: 39.986px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: #AD46FF;
`
const FamilyHeaderTitle = styled.div`
  color: #59168B;
  text-align: right;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
`
const ImageIcon4 = styled(Image)`
  width: 20px;
  height: 20px;
  color: black;
`
const ImageIcon5 = styled(Image)`
  width: 16px;
  height: 16px;
`
const SearchInput = styled(TextField)`
  display: flex;
  width: 100%;
  border-radius: 6px;
  border: 0.909px solid #E2E8F0;
  background: #F8FAFC;
  align-items: center;
  color: rgba(15, 23, 42, 0.50);
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  .MuiOutlinedInput-root {
    padding: 0px;
    width 100%;
  }
  .MuiOutlinedInput-notchedOutline{
    border: 0px;
  }
`
const SearchContainer = styled.div`
  position: relative;
  width: 100%;
`
const SearchResultList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background: #FFF;
  border: 0.909px solid #E2E8F0;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.10);
  max-height: 220px;
  overflow-y: auto;
`
const SearchResultItem = styled.div`
  width: 100%;
  justify-content: flex-end;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 0.909px solid #F1F5F9;
  &:last-child { border-bottom: none; }
  &:hover { background: #EFF6FF; }
`
const SearchResultName = styled.div`
  color: #0F172A;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`
const SearchResultDetails = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`
const UserTypeCheckTitle1 = styled.div`
  color: #101828;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const StyledInputContainer = styled.div`
  width: 100%;
`
const StyledLabel = styled.div`
  display: flex;
  /*padding-left: 258.452px;*/
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
`
const StyledRequired = styled.div`
  color: #DC2626;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; 
`
const NewFamilyContainer = styled.div`
  display: flex; 
  flex-direction: column;
  align-items: flex-end;
  gap: 11.989px;
  align-self: stretch;
`
const NewFamilyNotification = styled.div`
  display: flex;
  height: 45.795px;
  padding: 12px 10px;
  justify-content: flex-start; 
  align-items: center;
  gap: 7.997px;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #BEDBFF;
  background: #EFF6FF;
  color: #1C398E;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const ChildContainer = styled.div`
  display: flex;
  padding: 17px;
  flex-direction: column;
  align-items: flex-start;
  gap: 7.997px;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #FEE685;
  background: #FFFBEB;
`
const ChildTitle = styled.div`
  display: flex;
  padding-right: 0.31px;
  justify-content: center;
  align-items: center;
  color: #7B3306;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
` 
const ChildInputContainer = styled.div`
  display: flex;
  padding-top: 16px;
  width: 100%;
  row-gap: 12px;
  column-gap: 12px;
  @media (max-width: 780px) {
    flex-direction: column;
  }
`
const ChildInputControl = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  height: 57.784px;
  flex-direction: column;
  align-items: flex-end;
  gap: 3.992px;
  grid-row: 1 / span 1;
  grid-column: 2 / span 1;
`
const AddChildButton = styled(Button)`
  display: flex;
  padding: 8.724px 0 7.261px 0;
  justify-content: center;
  align-items: center;
  gap: 7.116px;
  align-self: stretch;
  border-radius: 6px;
  background: #2563EB;
  color: white;
`
const ChildItem = styled.div`
  display: flex;
  height: 69.787px;
  padding: 0 11.989px;
  align-items: center; 
  gap: 11.989px;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.30);
`
const SpouseItem = styled.div`
  display: flex;
  height: 90px;
  padding: 0 11.989px;
  align-items: center; 
  gap: 11.989px;
  align-self: stretch;
  border-radius: 8px;
  border: 0.909px solid #E2E8F0;
  background: rgba(241, 245, 249, 0.30);
`

const ChildItemActions = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 3.991px;
`
const ChildItemContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`
const ImageChildIcon = styled(Image)`
  width: 20px;
  height: 20px;
`
const StyledIconButton = styled(IconButton)`
  padding: 8px;
`
const ChildItemContentSection1 = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
flex: 1 0 0;
`
const ChildItemText2 = styled.div`
  color: #0F172A;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const ChildItemText3 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`
const NoChildrenContainer = styled.div`
  display: flex;
  width: 100%;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.30);
  padding: 9.633px 11.991px 8.171px 11.406px;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #64748B;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`
const HouseholdContainer  = styled.div`
  display: flex;
  width: 100%;
  padding: 12.898px 12.898px 0.909px 12.898px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.30);
`
const HouseholdInnerContainer = styled.div`
  display: flex;
  width: 100%;
  padding-right: 0;
  gap: 7.997px;
  align-self: stretch;
`
const HouseholdContent = styled.div`
  display: flex;
  padding-bottom: 0;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`
const HouseholdTitle1 = styled.div`
  display: flex;
  height: 23.991px;
  padding-left: 1051.221px;
  justify-content: flex-end;
  align-items: center;
  color: rgba(15, 23, 42, 0.80);
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const HouseholdTitle2 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const HouseholdTitle3 = styled.div`
  color: #64748B;
  font-family: Rubik;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
const NewHouseholdButton = styled(Button)`
  display: flex;
  padding: 8.724px 16.04px 7.261px 15.994px;
  justify-content: center; 
  align-items: center;
  border-radius: 6px;
  background: #2563EB;
  color: #FFF;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`                     
const NewHouseholdCancelButton = styled(Button)`
  display: flex;
  padding: 8.724px 15.074px 7.261px 15.994px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid #E4E9F2;
  background: #F1F5F9;
  color: #0F172A;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
`
const NewHouseholdContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 7.997px;
  align-self: stretch;
`
const ChildManualTitle = styled.div`
  color: #BB4D00;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  display: flex;
  padding: 1.898px 7px 2.074px 7.997px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: #FEF3C6;
`
const ChildTitle1 = styled.div`
  width: 100%;
  display: flex;
  height: 23.991px;
  align-items: center;
  gap: 7.997px;
  align-self: stretch;
`

export type FamilyPayload = {
  household: {
    id?: string
    firstName?: string
    lastName?: string
  } | null

  spouse: {
    mode: 'select' | 'new' | null
    id?: string 
    firstName?: string
    lastName?: string
    middleName?: string
    phone?: string
    identityNumber?: string
  } | null

  children: Array<{
    mode: 'select' | 'new'
    id?: string  
    firstName: string
    lastName: string
    middleName?: string
    phone?: string
    identityNumber?: string
    birthDate?: string
    gender?: string
  }>
}

const FamilySection = ({ value, onChange, disableEdit, houseNumber, currentUserId = 0 }) => {
  const { t } = useTranslation('members')

  const { orgs, imsUsersStore, user: userStore } = useStore()
  const [familyBtnActive, setBtnFamilyActive] = useState("select_from_list")
  const [childBtnActive, setBtnChildActive] = useState("select_from_list")

  const mode = familyBtnActive === 'add_new' ? 'new' : 'select'

  useEffect(() => {
    update({ spouse: value.spouse ? { ...value.spouse, mode } : { mode } })
  }, [familyBtnActive])

  const addChild = (child) => {
    update({
      children: [...value.children, child]
    })

    setChildValidation({ firstName: true, lastName: true })
  }

  const removeChild = (index: number) => {
    update({
      children: value.children.filter((_, i) => i !== index)
    })
  }

  const update = (patch) => {
    onChange({ ...value, ...patch })
  }

  const [householdMode, setHouseholdMode] = useState<'select' | 'create'>('select')
  const [householdSearch, setHouseholdSearch] = useState('')
  const [householdResults, setHouseholdResults] = useState<any[]>([])
  const [householdDropdownOpen, setHouseholdDropdownOpen] = useState(false)

  useEffect(() => {
    fetchHouseholds().then(res => setHouseholdResults(Array.isArray(res) ? res : []))
  }, [])

  const filteredHouseholds = householdSearch.trim().length < 1
    ? householdResults
    : householdResults.filter(h => h.houseHoldName?.toLowerCase().includes(householdSearch.toLowerCase()))

  const selectHousehold = (h: any) => {
    update({ household: { id: h.id, firstName: h.houseHoldName, createdAt: h.id == 0 ? new Date() : new Date(h.created) } })
    setHouseholdSearch('')
    setHouseholdDropdownOpen(false)
    setHouseholdSearch(h.houseHoldName)
    setShowSelectedHousehold(true)
  }

  const [spouseSearch, setSpouseSearch] = useState('')
  const [spouseDropdownOpen, setSpouseDropdownOpen] = useState(false)

  const [childSearch, setChildSearch] = useState('')
  const [childDropdownOpen, setChildDropdownOpen] = useState(false)

  const filteredSpouses = spouseSearch.length < 2
    ? []
    : imsUsersStore.allUsers.filter((u: any) => {
        const id = u.userId ?? u.id
        if (id === currentUserId) return false
        const s = spouseSearch.toLowerCase()
        return u.fullName?.toLowerCase().includes(s)
          || u.nickname?.toLowerCase().includes(s)
          || u.israelId?.toLowerCase().includes(s)
          || u.mainMobilePhone?.toLowerCase().includes(s)
          || u.email?.toLowerCase().includes(s)
      })

  const filteredChildren = childSearch.length < 2
    ? []
    : imsUsersStore.allUsers.filter((u: any) => {
        const id = u.userId ?? u.id
        if (id === currentUserId) return false
        const s = childSearch.toLowerCase()
        return u.fullName?.toLowerCase().includes(s)
          || u.nickname?.toLowerCase().includes(s)
          || u.israelId?.toLowerCase().includes(s)
          || u.mainMobilePhone?.toLowerCase().includes(s)
          || u.email?.toLowerCase().includes(s)
      })

  const selectSpouse = (user: any) => {
    const [firstName, ...rest] = (user.fullName || '').split(' ')
    update({ spouse: { mode: 'select', id: user.userId ?? user.id, firstName, lastName: rest.join(' '), phone: user.mainMobilePhone, identityNumber: user.israelId } })
    setSpouseSearch('')
    setShowSpouseDForm(false)
    setSpouseDropdownOpen(false)
  }

  const selectChild = (user: any) => {
    const [firstName, ...rest] = (user.fullName || '').split(' ')
    addChild({ mode: 'select', id: user.userId ?? user.id, firstName, lastName: rest.join(' '), phone: user.mainMobilePhone, identityNumber: user.israelId })
    setChildSearch('')
    setChildDropdownOpen(false)
  }

  const [editingChildIndex, setEditingChildIndex] = useState<number | null>(null)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [middleName, setMiddleName] = useState('')
  const [phone, setPhone] = useState('')
  const [identityNumber, setIdentityNumber] = useState('')
  const [showSpouseForm, setShowSpouseDForm] = useState(value.spouse)
  const [showSelectedHousehold, setShowSelectedHousehold] = useState(true)
  const [showChildSearch, setShowChildSearch] = useState(false)
  const [birthDate, setBirthDate] = useState<Date | null>(null)
  const [gender, setGender] = useState<string | undefined>(undefined)

  const [childValidation, setChildValidation] = useState({ firstName: true, lastName: true, identityNumber: true, phone: false })
  const [spouseValidation, setSpouseValidation] = useState({ firstName: true, lastName: true, phone: true, identityNumber: true })

  const setChildValidationError = (patch) => setChildValidation(prev => ({ ...prev, ...patch }))
  const removeSpouse = () => {
    update({ spouse: null })
    setShowSpouseDForm(true)
  }

  const isSpouseEmpty = () => {
    if (value.spouse && value.spouse.id > 0) {
      return false
    }

    return showSpouseForm
  }

  function formatDate(date) {
    if (!date) return "";

    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  const normalizePhone = (v: string): string => {
    const stripped = v.replace(/-/g, '')
    return /^0\d{9}$/.test(stripped) ? '+972' + stripped.slice(1) : stripped
  }

  const displayPhone = (v: string): string => {
    const raw = v?.startsWith('+972') ? '0' + v.slice(4) : (v || '')
    return raw.length >= 3 ? raw.slice(0, 2) + '-' + raw.slice(2) : raw
  }

  const validateIsraeliPhone = (phone: string): boolean => {
    const stripped = phone.replace(/-/g, '')
    return /^\+972\d{9}$/.test(stripped) || /^0\d{9}$/.test(stripped)
  }

  const validateIsraeliId = (id: string): boolean => {
    if (!/^\d{9}$/.test(id)) return false
    let sum = 0
    for (let i = 0; i < 9; i++) {
      let digit = parseInt(id[i]) * ((i % 2) + 1)
      if (digit > 9) digit -= 9
      sum += digit
    }
    return sum % 10 === 0
  }

  const getAge = (date: Date | null): number | null => {
    if (!date) return null
    const today = new Date()
    const birth = new Date(date)
    let age = today.getFullYear() - birth.getFullYear()
    const monthDiff = today.getMonth() - birth.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) age--
    return age
  }

  const resetChildForm = () => {
    setFirstName('')
    setLastName('')
    setMiddleName('')
    setPhone('')
    setIdentityNumber('')
    setBirthDate(null)
    setGender(undefined)
    setEditingChildIndex(null)
    setChildValidation({ firstName: true, lastName: true, identityNumber: true, phone: false })
  }

  const startEditChild = (index: number) => {
    const child = value.children[index]
    setFirstName(child.firstName || '')
    setLastName(child.lastName || '')
    setMiddleName(child.middleName || '')
    setPhone(child.phone || '')
    setIdentityNumber(child.identityNumber || '')
    setBirthDate(child.birthDate || null)
    setGender(child.gender)
    setEditingChildIndex(index)
    setBtnChildActive('add_new')
    setChildValidation({ firstName: false, lastName: false, identityNumber: false, phone: false })
  }

  return (
    <Section>
        <FamilyHeader>
            <ImageIcon3 src={FamilyIcon}/>
            <FamilyHeaderTitle>משפחה</FamilyHeaderTitle>
        </FamilyHeader>
        <FamilyContainer>
            <FamilyContainerBeitAv>
                <FamilyContainerBeitAvHeader>
                    <ImageIcon4 src={Users2}/>
                    שם פרטי</FamilyContainerBeitAvHeader>
                {!disableEdit && householdMode === 'select' && (
                  <SearchContainer> 
                    <StyledLabel>שם פרטי <StyledRequired>*</StyledRequired></StyledLabel>
                    <SearchInput
                      role='search'
                      value={householdSearch}
                      placeholder="חפש שם פרטי..."
                      variant="outlined"
                      InputProps={{ startAdornment: <Image src={Search} /> }}
                      onChange={e => { setHouseholdSearch(e.target.value); setHouseholdDropdownOpen(true) }}
                      onFocus={() => setHouseholdDropdownOpen(true)}
                      onClick={() => setHouseholdDropdownOpen(true)}
                      onBlur={() => setTimeout(() => setHouseholdDropdownOpen(false), 150)}
                    />
                    {householdDropdownOpen && filteredHouseholds.length > 0 && (
                      <SearchResultList>
                        {filteredHouseholds.map((h: any) => (
                          <SearchResultItem key={h.id} onMouseDown={e => e.preventDefault()} onClick={() => selectHousehold(h)}>
                            <SearchResultName>{h.houseHoldName}</SearchResultName>
                          </SearchResultItem>
                        ))}
                      </SearchResultList>
                    )}
                  </SearchContainer>
                )}

                {!disableEdit && householdMode === 'create' && (
                  <StyledInputContainer>
                    <ValidatedPopulationInput
                      id="household-firstName"
                      label={"שם בית אב חדש"}
                      value={value.household?.firstName || ''}
                      onChange={v => update({ household: { id: 0, firstName: v, createdAt: new Date() } })}
                      placeholder=""
                      required={false}
                      setValidationError={() => null}
                      errorText="שדה חובה"
                      icon={null}
                    />
                    <StyledLabel style={{fontSize: '12px', color:'#0f172a', paddingTop: '5px'}}>מספר בית אב ייווצר אוטומטית</StyledLabel>
                  </StyledInputContainer>
                )}

                {!disableEdit && (
                  householdMode === 'select'
                    ? <Button3 startIcon={<Add/>} onClick={() => { setHouseholdMode('create'); setShowSelectedHousehold(false); update({ household: { id: 0, firstName: '', createdAt: new Date() } }) }}>יצירת בית אב חדש</Button3>
                    : <NewHouseholdContainer>
                      <NewHouseholdButton onClick={() => {
                        setHouseholdMode('select')
                        setShowSelectedHousehold(true)
                      }}>צור בית אב</NewHouseholdButton>
                      <NewHouseholdCancelButton onClick={() => {
                        setHouseholdMode('select')
                        setShowSelectedHousehold(false)      
                        update({ household: { id: 0, firstName: '', createdAt: new Date() } })
                      }}>ביטול</NewHouseholdCancelButton>
                    </NewHouseholdContainer>
                )}

              {value.household && showSelectedHousehold &&     
              <HouseholdContainer>
                <HouseholdInnerContainer>
                  <ImageIcon5 style={{ color: "#2563eb", marginTop: '2px' }} src={Household} />
                  <HouseholdContent>
                    <HouseholdTitle1>{value.household.firstName}ן</HouseholdTitle1>
                    {houseNumber && <HouseholdTitle2>מספר בית אב: {houseNumber}</HouseholdTitle2>}
                    {<HouseholdTitle3>נוצר בתאריך: {formatDate(value.household.createdAt)}</HouseholdTitle3>}
                  </HouseholdContent>
                </HouseholdInnerContainer>
              </HouseholdContainer>}
            </FamilyContainerBeitAv>

            <FamilyContainerSpourse>
                <FamilyContainerBeitAvHeader>
                    <ImageIcon4 src={FamilyIcon2}/>בן/בת זוג
                </FamilyContainerBeitAvHeader>

                {(!disableEdit) && <FamilyButtonContainer>
                    <ButtonFamily2 
                      active={'select_from_list' == familyBtnActive}
                      onClick={() => { setBtnFamilyActive('select_from_list') }} 
                      startIcon={<ImageIcon4 src={Users3}/>}
                    >בחר מהמערכ                    </ButtonFamily2>
                    <ButtonFamily1 
                      active={'add_new' == familyBtnActive} 
                      onClick={() => { setBtnFamilyActive('add_new') }} 
                      startIcon={<Add/>}
                    >הזנה ידנית
                    </ButtonFamily1>
                </FamilyButtonContainer>}

                {(!disableEdit) && 'select_from_list' == familyBtnActive &&
                <SearchContainer>
                    <SearchInput
                        role='search'
                        value={spouseSearch}
                        placeholder={`חפש בן/בת זוג...`}
                        variant="outlined"
                        InputProps={{ startAdornment: <Image src={Search} /> }}
                        onChange={e => { setSpouseSearch(e.target.value); setSpouseDropdownOpen(true) }}
                        onFocus={() => setSpouseDropdownOpen(true)}
                        onClick={() => setSpouseDropdownOpen(true)}
                        onBlur={() => setTimeout(() => setSpouseDropdownOpen(false), 150)}
                    />
                    {spouseDropdownOpen && filteredSpouses.filter((u: any) => (u.userId ?? u.id) !== value.spouse?.id).length > 0 && (
                      <SearchResultList>
                        {filteredSpouses.filter((u: any) => (u.userId ?? u.id) !== value.spouse?.id).map((user: any) => (
                          <SearchResultItem key={user.userId ?? user.id} onMouseDown={e => e.preventDefault()} onClick={() => selectSpouse(user)}>
                            <SearchResultName>{user.fullName}</SearchResultName>
                            <SearchResultDetails>{user.mainMobilePhone} • ת.ז. {user.israelId}</SearchResultDetails>
                          </SearchResultItem>
                        ))}
                      </SearchResultList>
                    )}
                </SearchContainer>}
                 {('add_new' == familyBtnActive) &&
                  <NewFamilyContainer>
                    <NewFamilyNotification><ImageIcon5 src={Alert2}/>השתמש באפשרות זו רק אם בן/בת הזוג לא רשום/ה במערכת</NewFamilyNotification>
                    <StyledInputContainer>
                      <ValidatedPopulationInput
                        id="spouse-firstName"
                        label="בית אב"
                        value={value.spouse?.firstName || ''}
                        onChange={v => update({ spouse: { ...value.spouse, firstName: v } })}
                        placeholder=""
                        required={true}
                        setValidationError={error => setSpouseValidation({ firstName: error })}
                        errorText="שדה חובה"
                        icon={null}
                      />
                    </StyledInputContainer>
                    <StyledInputContainer>
                      <ValidatedPopulationInput
                        id="spouse-lastName"
                        label="שם משפחה"
                        value={value.spouse?.lastName || ''}
                        onChange={v => update({ spouse: { ...value.spouse, lastName: v } })}
                        placeholder=""
                        required={true}
                        setValidationError={error => setSpouseValidation({ lastName: error })}
                        errorText="שדה חובה"
                        icon={null}
                      />
                    </StyledInputContainer>
                    <StyledInputContainer>
                      <ValidatedPopulationInput
                        id="spouse-middleName"
                        label="שם אמצעי"
                        value={value.spouse?.middleName || ''}
                        onChange={v => update({ spouse: { ...value.spouse, middleName: v } })}
                        placeholder=""
                        required={false}
                        setValidationError={() => null}
                        errorText=""
                        icon={null}
                      />
                    </StyledInputContainer>
                    <StyledInputContainer>
                      <ValidatedPopulationInput
                        id="spouse-phone"
                        label="טלפון"
                        value={displayPhone(value.spouse?.phone || '')}
                        onChange={v => update({ spouse: { ...value.spouse, phone: normalizePhone(v) } })}
                        placeholder="05-XXXXXXXX"
                        required={true}
                        setValidationError={error => setSpouseValidation({ phone: error })}
                        customValidation={validateIsraeliPhone}
                        errorText="מספר טלפון לא תקין (לדוגמה: 05-22222222)"
                        icon={null}
                        dir="ltr"
                      />
                    </StyledInputContainer>
                    <StyledInputContainer>
                      <ValidatedPopulationInput
                        id="spouse-identityNumber"
                        label="תעודת זהות"
                        value={value.spouse?.identityNumber || ''}
                        onChange={v => update({ spouse: { ...value.spouse, identityNumber: v } })}
                        placeholder="9 ספרות"
                        required={true}
                        setValidationError={error => setSpouseValidation({ identityNumber: error })}
                        customValidation={validateIsraeliId}
                        errorText="תעודת זהות לא תקינה (9 ספרות)"
                        icon={null}
                      />
                    </StyledInputContainer>
                    <AddChildButton 
                      disabled={Object.values(spouseValidation).filter(res => res).length > 0}
                      onClick={() => {
                        setShowSpouseDForm(false)
                        setSpouseValidation({ firstName: true, lastName: true, phone: true, identityNumber: true })
                        setBtnFamilyActive('select_from_list')
                      }}>שמור</AddChildButton>
                  </NewFamilyContainer>
                 }

                {value.spouse && !isSpouseEmpty() &&   
                  <SpouseItem>
                      <ImageIcon5 src={User6}/>
                      <ChildItemContent>
                        <ChildItemContentSection1>
                          <ChildTitle1>
                            <ChildItemText2>{value.spouse.firstName} {value.spouse.middleName} {value.spouse.lastName}</ChildItemText2>
                          </ChildTitle1>
                          <ChildItemText3>{displayPhone(value.spouse.phone || '')} • ת.ז. {value.spouse.identityNumber}</ChildItemText3>
                          {value.spouse.id > 0 && <ChildItemText3>נבחר מהמערכת</ChildItemText3>}
                        </ChildItemContentSection1>
                        
                      </ChildItemContent>
                      <ChildItemActions>
                        <StyledIconButton onClick={() => removeSpouse()}> <ActionsImage src={CloseIcon} /></StyledIconButton>
                      </ChildItemActions>
                  </SpouseItem>
                }
            </FamilyContainerSpourse>
        
            <FamilyContainerSpourse>
                <FamilyContainerBeitAvHeader>
                    <ImageIcon4 src={ChildIcon}/>ילדים
                </FamilyContainerBeitAvHeader>
                  {!disableEdit && <UserTypeCheckTitle1>ילדים משויכים:</UserTypeCheckTitle1>}
                  {value.children.length == 0 && <NoChildrenContainer>אין ילדים משויכים</NoChildrenContainer>}
                  {value.children.map((child, index) =>
                    (<ChildItem key={index}>
                      <ImageChildIcon src={User5}/>
                      <ChildItemContent>
                        <ChildItemContentSection1>
                          <ChildTitle1>
                            <ChildItemText2>{child.firstName} {child.middleName} {child.lastName}</ChildItemText2>
                            {child.id == 0 ? <ChildManualTitle>הזנה ידנית</ChildManualTitle> : ''}
                          </ChildTitle1>
                          <ChildItemText3>{getAge(child.birthDate) != null ? `גיל ${getAge(child.birthDate)} • ` : ''}{child.gender} • {displayPhone(child.phone || '')}</ChildItemText3>
                        </ChildItemContentSection1>
                        
                      </ChildItemContent>
                      <ChildItemActions>
                        {child.id == 0 && <StyledIconButton onClick={() => startEditChild(index)}> <ActionsImage src={EditIcon2} /></StyledIconButton>}
                        <StyledIconButton onClick={() => removeChild(index)}> <ActionsImage src={CloseIcon} /></StyledIconButton>
                      </ChildItemActions>
                 </ChildItem>
                ))}

                {!disableEdit && <UserTypeCheckTitle1>הוסף ילד:</UserTypeCheckTitle1>}
                {!disableEdit && <FamilyButtonContainer>
                    <ButtonFamily2 
                      onClick={() => { 
                        setBtnChildActive('select_from_list'); 
                        setShowChildSearch(true); 
                      }} 
                      active={'select_from_list' == childBtnActive} 
                      startIcon={<ImageIcon4 src={Users3}/>}
                    >בחר מהמערכת</ButtonFamily2>
                    
                    <ButtonFamily1 
                      onClick={() => {
                        setBtnChildActive('add_new');
                        setShowChildSearch(false);
                      }} 
                      active={'add_new' == childBtnActive} 
                      startIcon={<Add/>}
                    >הזנה ידנית</ButtonFamily1>
                </FamilyButtonContainer>}
                {!disableEdit && 'select_from_list' == childBtnActive && showChildSearch &&
                  <SearchContainer>
                    <SearchInput
                      role='search'
                      value={childSearch}
                      placeholder={`חפש ילד...`}
                      variant="outlined"
                      InputProps={{ startAdornment: <Image src={Search} /> }}
                      onChange={e => { setChildSearch(e.target.value); setChildDropdownOpen(true) }}
                      onFocus={() => setChildDropdownOpen(true)}
                      onClick={() => setChildDropdownOpen(true)}
                      onBlur={() => setTimeout(() => setChildDropdownOpen(false), 150)}
                    />
                    {childDropdownOpen && filteredChildren.filter((u: any) => !value.children.some(c => c.id === (u.userId ?? u.id))).length > 0 && (
                      <SearchResultList>
                        {filteredChildren.filter((u: any) => !value.children.some(c => c.id === (u.userId ?? u.id))).map((user: any) => (
                          <SearchResultItem key={user.userId ?? user.id} onMouseDown={e => e.preventDefault()} onClick={() => selectChild(user)}>
                            <SearchResultName>{user.fullName}</SearchResultName>
                            <SearchResultDetails>{displayPhone(user.mainMobilePhone)} • ת.ז. {user.israelId}</SearchResultDetails>
                          </SearchResultItem>
                        ))}
                      </SearchResultList>
                    )}
                  </SearchContainer>}

                    {'add_new' == childBtnActive &&
                      <ChildContainer>
                        <ChildTitle>הזנת פרטי ילד ידנית</ChildTitle>
                        <ChildInputContainer>
                            <ChildInputControl>
                                <ValidatedPopulationInput
                                    id="child-firstName"
                                    label="שם פרטי"
                                    value={firstName}
                                    onChange={v => setFirstName(v)}
                                    placeholder="שם פרטי..."
                                    required={true}
                                    setValidationError={error => setChildValidationError({ firstName: error })}
                                    errorText="שדה חובה"
                                    icon={<Image src={FamilyIcon3} />}
                                />
                            </ChildInputControl>
                            <ChildInputControl>
                                <ValidatedPopulationInput
                                    id="child-lastName"
                                    label="שם משפחה"
                                    value={lastName}
                                    onChange={v => setLastName(v)}
                                    placeholder="שם משפחה..."
                                    required={true}
                                    setValidationError={error => setChildValidationError({ lastName: error })}
                                    errorText="שדה חובה"
                                    icon={<Image src={FamilyIcon3} />}
                                />
                            </ChildInputControl>
                        </ChildInputContainer>
                        <ChildInputContainer>
                            <ChildInputControl>
                                <ValidatedPopulationInput
                                    id="child-middleName"
                                    label="שם אמצעי"
                                    value={middleName}
                                    onChange={v => setMiddleName(v)}
                                    placeholder="שם אמצעי..."
                                    required={false}
                                    setValidationError={() => null}
                                    errorText=""
                                    icon={<Image src={FamilyIcon3} />}
                                />
                            </ChildInputControl>
                            <ChildInputControl>
                                <ValidatedPopulationInput
                                  id="child-phone"
                                  label="טלפון"
                                  value={displayPhone(phone)}
                                  onChange={v => setPhone(normalizePhone(v))}
                                  placeholder="05-XXXXXXXX"
                                  required={false}
                                  customValidation={v => v === '' || validateIsraeliPhone(v)}
                                  setValidationError={error => setChildValidationError({ phone: error })}
                                  errorText="מספר טלפון לא תקין (לדוגמה: 05-22222222)"
                                  errorText=""
                                  icon={<Image src={FamilyIcon4} />}
                                  dir="ltr"
                                />
                            </ChildInputControl>
                        </ChildInputContainer>
                        <ChildInputContainer>
                            <ChildInputControl>
                              <ValidatedPopulationInput
                                id="child-identityNumber"
                                label="ת.ז."
                                value={identityNumber}
                                onChange={v => setIdentityNumber(v)}
                                placeholder="מספר זהות..."
                                required={true}
                                customValidation={validateIsraeliId}
                                setValidationError={error => setChildValidationError({ identityNumber: error })}
                                errorText="תעודת זהות לא תקינה (9 ספרות)"
                                icon={<Image src={FamilyIcon6} />}
                              />
                            </ChildInputControl>
                            <ChildInputControl>
                              <StyledLabel>תאריך לידה</StyledLabel>
                              <DateInputWithCalendar
                                value={birthDate}
                                onChange={date => setBirthDate(date)}
                                inputBg={`rgb(248, 250, 252)`}
                                locale={userStore.dateFnsLocal}
                                icon={<Image src={FamilyIcon5} style={{ width: 16, height: 16, marginRight: 6 }} />}
                                fontSize="14px"
                              />
                            </ChildInputControl>
                        </ChildInputContainer>
                        <ChildInputContainer>
                            <ChildInputControl>
                              <StyledLabel>מגדר</StyledLabel>
                              <Select
                                variant="outlined"
                                value={gender || ''}
                                dir="ltr"
                                onChange={e => setGender(e.target.value as string)}
                                style={{ width: '100%', height: '42px', background: '#F8FAFC' }}
                              >
                                <MenuItem value="זכר">זכר</MenuItem>
                                <MenuItem value="נקבה">נקבה</MenuItem>
                                <MenuItem value="אחר">אחר</MenuItem>
                              </Select>
                            </ChildInputControl>
                            <ChildInputControl />
                         </ChildInputContainer>

                         <ChildInputContainer>
                            <ChildInputControl>
                              <AddChildButton
                                disabled={Object.values(childValidation).filter(res => res).length > 0}
                                startIcon={<Add/>}
                                onClick={() => {
                                  const childData = {
                                    id: 0,
                                    mode: 'new',
                                    firstName,
                                    lastName,
                                    middleName,
                                    phone,
                                    identityNumber,
                                    birthDate,
                                    gender
                                  }
                                  if (editingChildIndex !== null) {
                                    update({
                                      children: value.children.map((c, i) => i === editingChildIndex ? childData : c)
                                    })
                                  } else {
                                    addChild(childData)
                                  }
                                  resetChildForm()
                                }}
                              >{editingChildIndex !== null ? 'עדכן ילד' : 'הוסף ילד'}</AddChildButton>
                            </ChildInputControl>
                         </ChildInputContainer>
                      </ChildContainer>
                    }
            </FamilyContainerSpourse>
        </FamilyContainer>
    </Section>                
  )
}

export default observer(FamilySection)


